import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { helper } from 'src/environments/helper';
import {
    CererePriorityAddPayload,
    CererePriorityEditPayload,
} from '../cerere-priority.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CererePriorityService } from '../cerere-priority.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-edit-cerere-priority',
    templateUrl: './edit-cerere-priority.component.html',
    styleUrls: ['./edit-cerere-priority.component.scss'],
})
export class EditCererePriorityComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        bg_color: new FormControl(this.data.bg_color, [Validators.required]),
        time: new FormControl(this.data.time, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CererePriorityEditPayload,
        private dialogRef: MatDialogRef<EditCererePriorityComponent>,
        private cererePriorityService: CererePriorityService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.cererePriorityService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, bg_color, time, slug } = this.form
            .value as CererePriorityAddPayload;
        const updateStatus: CererePriorityEditPayload = {
            id: this.data.id,
            name,
            bg_color,
            time,
            slug,
        };

        this.cererePriorityService
            .updateCererePriority(updateStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }
}
